import {useMemo} from 'react';

import {ItemSubType, ItemType, useCharacterItemSearchQuery} from '../../../../../generated/types';
import {isSeparateKind} from '../../model/equipment';
import type {PickCategory, StartingItemInfo} from '../../model/starting-equipment';

/** все предметы базы с видами для выбора «музыкальный инструмент по вашему выбору» */
export function useStartingItems() {
	const {data, loading} = useCharacterItemSearchQuery();

	const items = useMemo(
		(): StartingItemInfo[] =>
			(data?.items || []).map((item) => {
				const categories: PickCategory[] = [];
				if (item.subType?.includes(ItemSubType.Instrument)) categories.push('instrument');
				if (item.type === ItemType.GamingSet) categories.push('gamingSet');
				if (item.type === ItemType.ArtisansTools) categories.push('artisansTools');
				const separate = isSeparateKind({type: item.type, subTypes: item.subType || []});
				return {id: item.id, title: item.title, categories, separate};
			}),
		[data],
	);
	const titles = useMemo(() => new Map(items.map((item) => [item.id, item.title])), [items]);

	return {items, titles, loading};
}
